import * as React from "react";
import { useSelector } from "react-redux";

import { Grid, Loader } from "semantic-ui-react";

import { AuditLogTable } from "../../../audit/components/AuditLogTable";

import { AuditLogEntryDto } from "../../../audit/model";

import { customerUserSelector, routeCustomerIdSelector, routeIdSelector } from "../selectors";
import { customerUserApi } from "../customerUserApi";

export const CustomerUserAuditLog = () => {
    const customerId = useSelector(routeCustomerIdSelector);
    const customerUserId = useSelector(routeIdSelector);
    const customerUser = useSelector(customerUserSelector);
    const [auditLogs, setAuditLogs] = React.useState<AuditLogEntryDto[] | null | undefined>(undefined);

    React.useEffect(() => {
        const getAuditLogs = async () => {
            if (customerId && customerUserId) {
                const data = await customerUserApi.getAuditLogs(customerId, customerUserId);
                setAuditLogs(data);
            }
        };

        if (auditLogs === undefined) {
            getAuditLogs();
        }

    }, [auditLogs, customerId, customerUserId]);

    if (auditLogs === undefined) {
        return <Loader active />;
    }

    return (
        <>
            <Grid className="nomargintop">
                <Grid.Row>
                    <Grid.Column>
                        <h1>Audit Log for {customerUser.firstName} {customerUser.surname}</h1>
                    </Grid.Column>
                </Grid.Row>
                <AuditLogTable auditLogs={auditLogs} />
            </Grid>
        </>
    );
};
